/* eslint-disable @typescript-eslint/ban-types */
import React, { createContext, PropsWithChildren, useContext, useEffect } from 'react';
import useLwp from '../use-lwp/use-lwp';
import { DesktopMessage, DesktopMessageStartLwpCall, useDesktop } from '@revenuewell/logic-desktop';

export interface LwpActionsContextProps {
  call: (phoneNumber: string) => void;
}

export const LwpActionsContext = createContext<LwpActionsContextProps>(null!);

export function LwpActionsProvider({ children }: PropsWithChildren<{}>) {
  const { call } = useLwp();
  const { isDesktopWidget, listenMessage, showWindow } = useDesktop();

  useEffect(() => {
    if (isDesktopWidget) {
      const unsubscribe = [
        listenMessage('desktop-start-lwp-call', (data: DesktopMessage) => {
          const { payload } = data as DesktopMessageStartLwpCall;
          call(payload.number.toString());
          setTimeout(() => showWindow(), 500);
        }),
      ];

      return () => unsubscribe.forEach((u) => u());
    }
  }, [call]);

  return <LwpActionsContext.Provider value={{call}}>{children}</LwpActionsContext.Provider>;
}

export function useLwpActions() {
  const context = useContext(LwpActionsContext);

  if (!context) throw new Error('useLwpActions must be used within the LwpActionsProvider');

  return context;
}
